import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next-sq",
  "use": "icon-next-sq-usage",
  "viewBox": "0 0 43 43",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 43\" id=\"icon-next-sq\"><rect x=\".501\" y=\".504\" width=\"41.141\" height=\"41.141\" rx=\"1.5\" stroke=\"currentColor\" /><path d=\"M23 15.932a.908.908 0 0 0-1.486.292.91.91 0 0 0 .199.994l2.932 2.933-9.36.014a.909.909 0 0 0 .004 1.817l9.384-.008-2.955 2.954a.908.908 0 1 0 1.285 1.286l4.498-4.498a.91.91 0 0 0-.004-1.287L23 15.933Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol